/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating, FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSONTyped, FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating';
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRatingToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsStorePageRating(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsStorePageRatingToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsStorePageOptionsRating.js.map